import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { FieldType, FormlyModule } from '@ngx-formly/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormService } from '../../../features/admin/modules/features/form-builder/form.service';
import { debounceTime, takeUntil } from 'rxjs';
import { injectDestroy } from 'ngxtension/inject-destroy';

@Component({
  selector: 'app-formly-form-builder',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormlyModule, FormsModule, ReactiveFormsModule],
  template: ``,
})
export class FormlyFormBuilderToGeneratedFormComponent extends FieldType implements OnInit {
  formService = inject(FormService);
  private destroy$ = injectDestroy();
  constructor() {
    super();
  }

  ngOnInit() {
    this.field.form.valueChanges.pipe(takeUntil(this.destroy$), debounceTime(500)).subscribe(() => {
      const generatedForm = this.formService.generateForm(this.model['form']);
      if (JSON.stringify(this.field.formControl.value) != JSON.stringify(generatedForm)) {
        this.field.formControl.patchValue(generatedForm);
      }
    });
  }
}
